const images = {
  icNurse: require('./Images/icNurse.png'),
  icMap: require('./Images/icMap.png'),
  icHospital: require('./Images/icHospital.png'),
  icTell: require('./Images/icon_dwelling_tel.svg'),
  icBot: require('./Images/icBot.png'),
}

export default images
